
import { createI18n } from "vue-i18n";
const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    },
    long: {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    },
    week: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long'
    },
    time: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }
  },
  'de': {
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    },
    long: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    },
    week: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long'
    },
    time: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }
  },
}
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default createI18n({
  locale:  localStorage.getItem('waos_rm.language') || process.env.VUE_APP_I18N_LOCALE ,
  legacy: false,
  datetimeFormats: dateTimeFormats,
  globalInjection: true,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
